// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";

// import _ from "lodash";
// import { verifyauthCheck, getSubscriptionPlanList } from "../handlers/adminApi";
// import { formatPriceInUSD } from "../handlers/helpers";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
// import chech from "../StyledComponents/img/check_circle.png";
// import { DotLoader } from "react-spinners";
// import { message } from "antd";

// function Subscription() {
//   const [isEditModalOpen, setEditModalOpen] = useState(false);
//   const [isSaveModalOpen, setSaveModalOpen] = useState(false);
//   const [subscriptionPlan, setSubscriptionPlan] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [isLoading, setIsLoading] = useState(true);
//   const [selectedPlan, setSelectedPlan] = useState(null);
//   const entriesPerPage = 5;
//   const navigate = useNavigate();
//   const location = useLocation();

//   const totalPages = Math.ceil(subscriptionPlan.length / entriesPerPage);
//   const indexOfLastEntry = currentPage * entriesPerPage;
//   const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;

//   const handlePageChange = (pageNumber) => {
//     if (pageNumber >= 1 && pageNumber <= totalPages) {
//       setCurrentPage(pageNumber);
//     }
//   };

//   const handleEditClick = (plan) => {
//     setSelectedPlan(plan); // Set the selected plan
//     setEditModalOpen(true); // Open the edit modal
//   };

//   const handleCancelEdit = (e) => {
//     e.preventDefault();
//     setEditModalOpen(false);
//   };

//   const handleSaveChanges = async (e) => {
//     e.preventDefault();
//     // setIsLoading(true);

//     if (!selectedPlan || !selectedPlan.sub_id) {
//       alert("Invalid subscription plan selected.");
//       return;
//     }

//     const updatedPlan = {
//       planName: _.get(selectedPlan, "plan_name", ""),
//       price: selectedPlan.price,
//       description: selectedPlan.description,
//     };

//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_HOSTNAME}/admin/subscriptions/edit-subscription/${selectedPlan.sub_id}`,
//         {
//           method: "PUT",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(updatedPlan),
//         },
//       );

//       const responseData = await response.json();
//       console.log("API Response Data:", responseData);

//       if (response.ok) {
//         // If the response is OK, hide the loading modal and show the success modal
//         setIsLoading(false);
//         setEditModalOpen(false); // Close edit modal
//         setSaveModalOpen(true); // Show save modal
//       } else {
//         setIsLoading(false);
//         setEditModalOpen(false);
//         message.error(
//           _.get(
//             responseData,
//             "message",
//             "An error occurred while updating the subscription plan.",
//           ),
//         );
//       }
//     } catch (error) {
//       setIsLoading(false);
//       setEditModalOpen(false);
//       message.error("An error occurred while updating the subscription plan.");
//       console.error("Error:", error); // Log the error details
//     }
//   };

//   const handleCancelSave = (e) => {
//     e.preventDefault();
//     setSaveModalOpen(false);
//     window.location.reload();
//   };

//   const hasRun = useRef(false);

//   const authCheck = async () => {
//     var resp = await verifyauthCheck();
//     if (resp != null) {
//       if (resp.status === true) {
//         navigate(location.pathname, {
//           state: { ...location.state, userData: resp.userData },
//         });
//       } else {
//         navigate("/");
//       }
//     }
//   };

//   const getSubscriptionPlan = async () => {
//     setIsLoading(true);
//     var resp = await getSubscriptionPlanList({ page: "1" });
//     const planData = _.get(resp, "data", []);
//     setSubscriptionPlan(planData);
//     setIsLoading(false);
//   };

//   useEffect(() => {
//     if (!hasRun.current) {
//       hasRun.current = true;
//       authCheck();
//       getSubscriptionPlan();
//     }
//   }, []);

//   return (
//     <div className="right" style={{ overflow: "hidden" }}>
//       <div className="title">
//         <h2>Manage Subscription Plans</h2>
//       </div>
//       {isLoading ? (
//         <div
//           className="loader-container"
//           style={{
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             height: "100%",
//             marginLeft: "450px",
//             marginTop: "90px",
//           }}
//         >
//           <DotLoader color="#F7812A" loading={isLoading} size={60} />
//         </div>
//       ) : (
//         <div className="table">
//           <table>
//             <tr>
//               <th>Plan Name</th>
//               <th>Price</th>
//               <th>Description</th>
//               <th>Order</th>
//               <th>Action</th>
//             </tr>

//             {subscriptionPlan.map((plan, index) => (
//               <tr key={index}>
//                 <td>{plan.plan_name}</td>
//                 <td>{formatPriceInUSD(plan.price)}</td>
//                 <td>{plan.description}</td>
//                 <td>{plan.order}</td>
//                 <td>
//                   <a
//                     onClick={() => handleEditClick(plan)} // Pass the plan object
//                     style={{
//                       color: "white",
//                       marginLeft: 10,
//                       padding: "10px 20px",
//                       borderRadius: "20px",
//                       textDecoration: "none",
//                       backgroundColor: "#F7812A",
//                       cursor: "pointer",
//                     }}
//                   >
//                     Edit
//                     <FontAwesomeIcon
//                       icon={faPenToSquare}
//                       style={{
//                         color: "white",
//                         marginLeft: 10,
//                       }}
//                     />
//                   </a>
//                 </td>
//               </tr>
//             ))}
//           </table>

//           <hr className="horizontal-line" />

//           {/* <div className="pagination">
//             <span>
//               Showing {Math.min(indexOfLastEntry, subscriptionPlan.length)} of {subscriptionPlan.length} entries
//             </span>
//             <div className="pagination-buttons">
//               {[...Array(totalPages)].map((_, index) => (
//                 <button
//                   key={index}
//                   onClick={() => handlePageChange(index + 1)}
//                   className={currentPage === index + 1 ? 'active' : ''}
//                 >
//                   {index + 1}
//                 </button>
//               ))}
//               <button
//                 onClick={() => handlePageChange(currentPage + 1)}
//                 disabled={currentPage === totalPages}
//               >
//                 Next
//               </button>
//             </div>
//           </div> */}
//         </div>
//       )}

//       {/* Edit Subscription Modal */}
//       {isEditModalOpen && selectedPlan && (
//         <>
//           <div className="modal-overlay"></div>
//           <div className="edit-form">
//             <div className="form">
//               <form>
//                 <h2>Edit Subscription</h2>
//                 <div className="form-group">
//                   <label htmlFor="planName">Plan Name</label>
//                   <input
//                     type="text"
//                     id="planName"
//                     value={selectedPlan.plan_name}
//                     onChange={(e) =>
//                       setSelectedPlan({
//                         ...selectedPlan,
//                         plan_name: e.target.value,
//                       })
//                     }
//                     required
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label htmlFor="price">Price</label>
//                   <input
//                     type="text"
//                     id="price"
//                     value={selectedPlan.price}
//                     onChange={(e) =>
//                       setSelectedPlan({
//                         ...selectedPlan,
//                         price: e.target.value,
//                       })
//                     }
//                     required
//                   />
//                   <i>AUD</i>
//                 </div>
//                 <div className="form-group">
//                   <label htmlFor="description">Plan Description</label>
//                   <textarea
//                     id="description"
//                     value={selectedPlan.description}
//                     onChange={(e) =>
//                       setSelectedPlan({
//                         ...selectedPlan,
//                         description: e.target.value,
//                       })
//                     }
//                     required
//                   ></textarea>
//                 </div>
//                 <div className="theme-btn">
//                   <div className="btn">
//                     <a
//                       style={{ cursor: "pointer" }}
//                       onClick={handleSaveChanges}
//                     >
//                       Save Changes
//                     </a>
//                   </div>
//                   <div className="btn btn2">
//                     <a style={{ cursor: "pointer" }} onClick={handleCancelEdit}>
//                       Cancel
//                     </a>
//                   </div>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </>
//       )}

//       {/* Save Changes Confirmation Modal */}
//       {isSaveModalOpen && (
//         <>
//           <div className="modal-overlay"></div>
//           <div className="edit-form change-sub">
//             <div className="form">
//               <form>
//                 <div className="logo">
//                   <img src={chech} alt="Check Icon" />
//                 </div>
//                 <h2>Changes Saved</h2>
//                 <p>Subscription details changed successfully!</p>
//                 <div className="btn">
//                   <a style={{ cursor: "pointer" }} onClick={handleCancelSave}>
//                     Close
//                   </a>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </>
//       )}
//     </div>
//   );
// }

// export default Subscription;

import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import _ from "lodash";
import { verifyauthCheck, getSubscriptionPlanList } from "../handlers/adminApi";
import { formatPriceInUSD } from "../handlers/helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import chech from "../StyledComponents/img/check_circle.png";
import { DotLoader } from "react-spinners";
import { message } from "antd";

function Subscription() {
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [isSaveModalOpen, setSaveModalOpen] = useState(false);
  const [subscriptionPlan, setSubscriptionPlan] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const entriesPerPage = 5;
  const navigate = useNavigate();
  const location = useLocation();

  const totalPages = Math.ceil(subscriptionPlan.length / entriesPerPage);
  const indexOfLastEntry = currentPage * entriesPerPage;
  const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const handleEditClick = (plan) => {
    setSelectedPlan(plan); // Set the selected plan
    setEditModalOpen(true); // Open the edit modal
  };

  const handleCancelEdit = (e) => {
    e.preventDefault();
    setEditModalOpen(false);
  };

  const handleSaveChanges = async (e) => {
    e.preventDefault();
    // setIsLoading(true);

    if (!selectedPlan || !selectedPlan.sub_id) {
      alert("Invalid subscription plan selected.");
      return;
    }

    const updatedPlan = {
      planName: _.get(selectedPlan, "plan_name", ""),
      price: selectedPlan.price,
      description: selectedPlan.description,
      order: selectedPlan.order,
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_HOSTNAME}/admin/subscriptions/edit-subscription/${selectedPlan.sub_id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatedPlan),
        },
      );

      const responseData = await response.json();
      console.log("API Response Data:", responseData);

      if (response.ok) {
        // If the response is OK, hide the loading modal and show the success modal
        setIsLoading(false);
        setEditModalOpen(false); // Close edit modal
        setSaveModalOpen(true); // Show save modal
      } else {
        setIsLoading(false);
        setEditModalOpen(false);
        message.error(
          _.get(
            responseData,
            "message",
            "An error occurred while updating the subscription plan.",
          ),
        );
      }
    } catch (error) {
      setIsLoading(false);
      setEditModalOpen(false);
      message.error("An error occurred while updating the subscription plan.");
      console.error("Error:", error); // Log the error details
    }
  };

  const handleCancelSave = (e) => {
    e.preventDefault();
    setSaveModalOpen(false);
    window.location.reload();
  };

  const hasRun = useRef(false);

  const authCheck = async () => {
    var resp = await verifyauthCheck();
    if (resp != null) {
      if (resp.status === true) {
        navigate(location.pathname, {
          state: { ...location.state, userData: resp.userData },
        });
      } else {
        navigate("/");
      }
    }
  };

  const getSubscriptionPlan = async () => {
    setIsLoading(true);
    var resp = await getSubscriptionPlanList({ page: "1" });
    const planData = _.get(resp, "data", []);
    setSubscriptionPlan(planData);
    setIsLoading(false);
  };

  useEffect(() => {
    if (!hasRun.current) {
      hasRun.current = true;
      authCheck();
      getSubscriptionPlan();
    }
  }, []);

  return (
    <div className="right" style={{ overflow: "hidden" }}>
      <div className="title">
        <h2>Manage Subscription Plans</h2>
      </div>
      {isLoading ? (
        <div
          className="loader-container"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            marginLeft: "450px",
            marginTop: "90px",
          }}
        >
          <DotLoader color="#F7812A" loading={isLoading} size={60} />
        </div>
      ) : (
        <div className="table">
          <table>
            <tr>
              <th>Plan Name</th>
              <th>Price</th>
              <th>Description</th>
              <th>Order</th>
              <th>Action</th>
            </tr>

            {subscriptionPlan.map((plan, index) => (
              <tr key={index}>
                <td>{plan.plan_name}</td>
                <td>{formatPriceInUSD(plan.price)}</td>
                <td>{plan.description}</td>
                <td>{plan.order}</td>
                <td>
                  <a
                    onClick={() => handleEditClick(plan)} // Pass the plan object
                    style={{
                      color: "white",
                      marginLeft: 10,
                      padding: "10px 20px",
                      borderRadius: "20px",
                      textDecoration: "none",
                      backgroundColor: "#F7812A",
                      cursor: "pointer",
                    }}
                  >
                    Edit
                    <FontAwesomeIcon
                      icon={faPenToSquare}
                      style={{
                        color: "white",
                        marginLeft: 10,
                      }}
                    />
                  </a>
                </td>
              </tr>
            ))}
          </table>

          <hr className="horizontal-line" />
        </div>
      )}

      {/* Edit Subscription Modal */}
      {isEditModalOpen && selectedPlan && (
        <>
          <div className="modal-overlay"></div>
          <div className="edit-form">
            <div className="form">
              <form>
                <h2>Edit Subscription</h2>
                <div className="form-group">
                  <label htmlFor="planName">Plan Name</label>
                  <input
                    type="text"
                    id="planName"
                    value={selectedPlan.plan_name}
                    onChange={(e) =>
                      setSelectedPlan({
                        ...selectedPlan,
                        plan_name: e.target.value,
                      })
                    }
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="price">Price</label>
                  <input
                    type="text"
                    id="price"
                    value={selectedPlan.price}
                    onChange={(e) =>
                      setSelectedPlan({
                        ...selectedPlan,
                        price: e.target.value,
                      })
                    }
                    required
                  />
                  <i>AUD</i>
                </div>
                <div className="form-group">
                  <label htmlFor="order">Display Order</label>
                  <input
                    type="number"
                    id="order"
                    value={selectedPlan.order ?? ""}
                    onChange={(e) =>
                      setSelectedPlan({
                        ...selectedPlan,
                        order: e.target.value,
                      })
                    }
                    placeholder="e.g. 1, 2, 3"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="description">Plan Description</label>
                  <textarea
                    id="description"
                    value={selectedPlan.description}
                    onChange={(e) =>
                      setSelectedPlan({
                        ...selectedPlan,
                        description: e.target.value,
                      })
                    }
                    required
                  ></textarea>
                </div>
                <div className="theme-btn">
                  <div className="btn">
                    <a
                      style={{ cursor: "pointer" }}
                      onClick={handleSaveChanges}
                    >
                      Save Changes
                    </a>
                  </div>
                  <div className="btn btn2">
                    <a style={{ cursor: "pointer" }} onClick={handleCancelEdit}>
                      Cancel
                    </a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </>
      )}

      {/* Save Changes Confirmation Modal */}
      {isSaveModalOpen && (
        <>
          <div className="modal-overlay"></div>
          <div className="edit-form change-sub">
            <div className="form">
              <form>
                <div className="logo">
                  <img src={chech} alt="Check Icon" />
                </div>
                <h2>Changes Saved</h2>
                <p>Subscription details changed successfully!</p>
                <div className="btn">
                  <a style={{ cursor: "pointer" }} onClick={handleCancelSave}>
                    Close
                  </a>
                </div>
              </form>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default Subscription;